module.exports = __webpack_public_path__ + "img/logoutN.8585938c.svg";